module.exports = __webpack_public_path__ + "img/34.fe78f3ca.jpg";